import React from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import { PlansBillingPage } from './PlansBillingPage';
import { AssistantPage } from '../Applications/copilot/AssistantPage';

export const BillingDashboard = () => {
  return (
    <EmployerLayout>
      <AssistantPage page="billing" />
      <div className="flex flex-col w-full">
        <div className="flex-1 flex flex-col">
          <PlansBillingPage />
        </div>
      </div>
    </EmployerLayout>
  );
};
